<template>
  <div>
    <div class="contentBox w">
      <div class="contentStitle">Recruitment process outsourcing</div>
      <div class="contentTitle">RPO招聘流程外包</div>
      <div class="contentLine">
        <span class="lineLeft"></span>
        <span class="lineMiddle"></span>
        <span class="lineRight"></span>
      </div>
      <div class="yjh_item">
        <div class="yjh_item_text text_left">
          <div class="text_box">
            <div class="text_line"></div>
            <div class="text_title">RPO招聘流程外包简介！</div>
          </div>
          <div class="text_content">
            云久鸿RPO招聘流程外包服务（RPO）将根据您的具体需求，提供高效的招聘流程外包服务。在服务过程中，我们会为您精心设计招聘流程、制定选拔标准、进行人才寻访选拔，并办理相关的入职事宜，帮助企业提升招聘效率，提高招聘质量，降低招聘的成本。
          </div>
          <div class="text_otal">
            优势：企业可以减少劳动争议，自主灵活用工，提升企业招聘效率，保证招聘质量，并降低企业招聘的成本，使企业能更专注于核心业务的发展，提升企业核心竞争力，真正实现"省心"、"省力"、"省钱"。
          </div>
        </div>
        <div class="yjh_item_img">
          <img :src="src.qyfw" alt srcset />
        </div>
      </div>
    </div>
    <div class="mobile_contentBox">
      <div class="contentTitle noStitle">RPO招聘流程外包</div>
      <div class="contentLine">
        <span class="lineLeft"></span>
        <span class="lineMiddle"></span>
        <span class="lineRight"></span>
      </div>
      <div class="mobile_yjh_item">
        <div class="mobile_yjh_item_text">
          <div class="text_line"></div>
          <div class="text_title">RPO招聘流程外包简介！</div>
        </div>
        <div class="mobile_yjh_item_content">
          云久鸿RPO招聘流程外包服务（RPO）将根据您的具体需求，提供高效的招聘流程外包服务。在服务过程中，我们会为您精心设计招聘流程、制定选拔标准、进行人才寻访选拔，并办理相关的入职事宜，帮助企业提升招聘效率，提高招聘质量，降低招聘的成本。
        </div>
        <div class="mobile_yjh_item_otal">
          优势：企业可以减少劳动争议，自主灵活用工，提升企业招聘效率，保证招聘质量，并降低企业招聘的成本，使企业能更专注于核心业务的发展，提升企业核心竞争力，真正实现"省心"、"省力"、"省钱"。
        </div>

        <div class="mobile_yjh_item_img">
          <img :src="src.qyfw" alt srcset />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import src from "../../../utils/assets";
export default {
  data() {
    return {
      src: src,
    };
  },
}
</script>

<style lang="less" scoped></style>
